const apiAccount = {
    account: '/Account',
}


export default apiAccount